/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CallCardModel } from '../model/call-card-model';
// @ts-ignore
import { CallDetailModel } from '../model/call-detail-model';
// @ts-ignore
import { CallStatus } from '../model/call-status';
// @ts-ignore
import { CallType } from '../model/call-type';
// @ts-ignore
import { SeekDirection } from '../model/seek-direction';
// @ts-ignore
import { SeekResultCallRowModel } from '../model/seek-result-call-row-model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class CallResourceService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get Call Card
     * @param callId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallCard(callId: string, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CallCardModel>;
    public getCallCard(callId: string, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CallCardModel>>;
    public getCallCard(callId: string, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CallCardModel>>;
    public getCallCard(callId: string, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getCallCard.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/calls/${this.configuration.encodeParam({name: "callId", value: callId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/card`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CallCardModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Call Details By Call Id
     * @param callId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallDetailsByCallId(callId: string, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<CallDetailModel>>;
    public getCallDetailsByCallId(callId: string, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<CallDetailModel>>>;
    public getCallDetailsByCallId(callId: string, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<CallDetailModel>>>;
    public getCallDetailsByCallId(callId: string, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling getCallDetailsByCallId.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/calls/${this.configuration.encodeParam({name: "callId", value: callId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/details`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<CallDetailModel>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Call List
     * @param category 
     * @param cityIds 
     * @param counted 
     * @param countryIds 
     * @param date 
     * @param dateFrom 
     * @param dateTo 
     * @param dow 
     * @param dropOff 
     * @param escalated 
     * @param followUp 
     * @param hasFlags 
     * @param hasOrder 
     * @param hour 
     * @param limit 
     * @param missed 
     * @param operatorId 
     * @param phone 
     * @param recovered 
     * @param seek 
     * @param seekDir 
     * @param sentiment 
     * @param statuses 
     * @param type 
     * @param tz 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallList(category?: string, cityIds?: Array<number>, counted?: boolean, countryIds?: Array<number>, date?: string, dateFrom?: string, dateTo?: string, dow?: number, dropOff?: string, escalated?: boolean, followUp?: boolean, hasFlags?: boolean, hasOrder?: boolean, hour?: number, limit?: number, missed?: boolean, operatorId?: number, phone?: string, recovered?: boolean, seek?: string, seekDir?: SeekDirection, sentiment?: string, statuses?: Array<CallStatus>, type?: CallType, tz?: string, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SeekResultCallRowModel>;
    public getCallList(category?: string, cityIds?: Array<number>, counted?: boolean, countryIds?: Array<number>, date?: string, dateFrom?: string, dateTo?: string, dow?: number, dropOff?: string, escalated?: boolean, followUp?: boolean, hasFlags?: boolean, hasOrder?: boolean, hour?: number, limit?: number, missed?: boolean, operatorId?: number, phone?: string, recovered?: boolean, seek?: string, seekDir?: SeekDirection, sentiment?: string, statuses?: Array<CallStatus>, type?: CallType, tz?: string, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SeekResultCallRowModel>>;
    public getCallList(category?: string, cityIds?: Array<number>, counted?: boolean, countryIds?: Array<number>, date?: string, dateFrom?: string, dateTo?: string, dow?: number, dropOff?: string, escalated?: boolean, followUp?: boolean, hasFlags?: boolean, hasOrder?: boolean, hour?: number, limit?: number, missed?: boolean, operatorId?: number, phone?: string, recovered?: boolean, seek?: string, seekDir?: SeekDirection, sentiment?: string, statuses?: Array<CallStatus>, type?: CallType, tz?: string, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SeekResultCallRowModel>>;
    public getCallList(category?: string, cityIds?: Array<number>, counted?: boolean, countryIds?: Array<number>, date?: string, dateFrom?: string, dateTo?: string, dow?: number, dropOff?: string, escalated?: boolean, followUp?: boolean, hasFlags?: boolean, hasOrder?: boolean, hour?: number, limit?: number, missed?: boolean, operatorId?: number, phone?: string, recovered?: boolean, seek?: string, seekDir?: SeekDirection, sentiment?: string, statuses?: Array<CallStatus>, type?: CallType, tz?: string, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>category, 'category');
        if (cityIds) {
            cityIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'city_ids');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>counted, 'counted');
        if (countryIds) {
            countryIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'country_ids');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>date, 'date');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateFrom, 'date_from');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dateTo, 'date_to');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dow, 'dow');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>dropOff, 'drop_off');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>escalated, 'escalated');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>followUp, 'follow_up');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hasFlags, 'has_flags');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hasOrder, 'has_order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>hour, 'hour');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>limit, 'limit');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>missed, 'missed');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>operatorId, 'operator_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>phone, 'phone');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>recovered, 'recovered');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>seek, 'seek');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>seekDir, 'seek_dir');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sentiment, 'sentiment');
        if (statuses) {
            statuses.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'statuses');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>type, 'type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>tz, 'tz');

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/calls/list`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SeekResultCallRowModel>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Save City Id For Call
     * @param callId 
     * @param cityId 
     * @param component Vanilla component (e.g. manager, cc, profile, cashbox)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveCityIdForCall(callId: string, cityId: number, component?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public saveCityIdForCall(callId: string, cityId: number, component?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public saveCityIdForCall(callId: string, cityId: number, component?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public saveCityIdForCall(callId: string, cityId: number, component?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (callId === null || callId === undefined) {
            throw new Error('Required parameter callId was null or undefined when calling saveCityIdForCall.');
        }
        if (cityId === null || cityId === undefined) {
            throw new Error('Required parameter cityId was null or undefined when calling saveCityIdForCall.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (component !== undefined && component !== null) {
            localVarHeaders = localVarHeaders.set('component', String(component));
        }

        // authentication (apiKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('apiKey', 'X-API-Key', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/vn/calls/${this.configuration.encodeParam({name: "callId", value: callId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/cities/${this.configuration.encodeParam({name: "cityId", value: cityId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('patch', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
